import {Search} from '../stores/Search';
import * as filtersSerializer from './filters';
import {Form} from '../../Form/stores/Form';
import {Filter} from '../stores/Filter';
import {getLocalizedText, texts} from '../../../constants/TextConst';
import {SEARCHES_MAX_NUM} from '../consts/searches';

type QueryName = 'query1name' | 'query2name'; // etc.. until 19

type InputJson = {[queryname in QueryName]: string} & {querydefaultnum: string};

interface SerializedJson {
    list: Array<Partial<Search>>;
    defaultIdx: string;
}

export function serialize(json: InputJson): SerializedJson {
    const list = [];
    for (let i = 1; i <= SEARCHES_MAX_NUM; i++) {
        const queryName = 'query' + i + 'name';
        if (json[queryName]) {
            list.push({
                name: json[queryName],
                serverIdx: i
            });
        }
    }
    return {
        list,
        defaultIdx: json.querydefaultnum
    };
}

export function serializeQueryFilters(
    form,
    json
): {query: string; filters: Filter[]; ignoreCase: boolean} {
    const jsonForm = json && extractForm(json);
    if (jsonForm && jsonForm.QueryFilters) {
        for (const filter in jsonForm.QueryFilters) {
            if (jsonForm.QueryFilters[filter].table === form.table) {
                const queryValues = serializeQueryValues(
                    form,
                    jsonForm.QueryFilters[filter].QueryValues
                );
                return {
                    query: jsonForm.QueryFilters[filter].query,
                    filters: queryValues,
                    ignoreCase: jsonForm.QueryFilters[filter].ignorecase === '1'
                };
            }
        }
    }
    return null;
}

export function serializeSearchesDlg(form, json) {
    const jsonForm = json && extractForm(json);
    const searches = {saved: [], previous: []};
    if (jsonForm && jsonForm.QueryDlg) {
        let prevIndex = 0;
        for (const search in jsonForm.QueryDlg) {
            if (jsonForm.QueryDlg[search].saved === '1') {
                const serializedSearch = {ignoreCase: false, filters: []};
                serializedSearch.ignoreCase = jsonForm.QueryDlg[search].ignorecase === '1';
                const sortedQueryValues = jsonForm.QueryDlg[search].QueryValues.sort(
                    (a, b) => a.sort - b.sort
                );
                serializedSearch.filters = serializeQueryValues(form, sortedQueryValues);
                searches.saved[jsonForm.QueryDlg[search].query] = serializedSearch;
            } else {
                if (!jsonForm.QueryDlg[search].isNew) {
                    prevIndex++;
                    const serializedSearch = {
                        ignoreCase: false,
                        filters: [],
                        isPrevious: true,
                        name: `${getLocalizedText(texts.previousSearch)} ${prevIndex}`
                    };
                    serializedSearch.ignoreCase = jsonForm.QueryDlg[search].ignorecase === '1';
                    serializedSearch.filters = serializeQueryValues(
                        form,
                        jsonForm.QueryDlg[search].QueryValues
                    );
                    searches.previous[prevIndex - 1] = serializedSearch;
                }
            }
        }
    }
    return searches;
}

export function serializeQueryValues(form: Form, queryValues): Filter[] {
    const filters = [];
    queryValues.forEach((queryValue, index) => {
        const column = form.columnsMap.get(queryValue.field.toString());
        if (column) {
            const filter = filtersSerializer.serialize(column, queryValue, index);
            filters.push(filter);
        }
    });
    return filters;
}

export function extractForm(json) {
    return json.Form && json.Form[0];
}

interface QueryRow {
    newquery;
    queryname;
    oldquery;
    oldIndex;
    isdefault;
}

// interface outputJson {
// 	tables : outputJsonNode
// }

// interface outputJsonNode {
// 	tableName: string;
// 	rows?: [{string : string} | outputJson}];
// }

export function deserialize(list: Array<Search>) {
    const outputJson = {tableName: 'QueryDesign', rows: []};
    list.forEach(query => {
        const row = {} as QueryRow;
        row.newquery = query.index;
        row.queryname = query.name;
        row.oldquery = query.serverIdx;
        row.isdefault = query.isDefault ? '1' : '0';
        outputJson.rows.push(row);
    });
    return {tables: [outputJson]};
}
